import { downloadBase64File } from "../../../../../common/utils/download_utils";
import { IGetReportOrdemComprasLoteUseCase } from "../../../presentation/useCases/read/get_report_ordem_compras_lote_use_case";
import { IReportsRepository } from "../../repositories/reports_repository";

import dayjs from "dayjs";

/**
 * GetReportOrdemComprasLoteUseCase
 */

export class GetReportOrdemComprasLoteUseCase implements IGetReportOrdemComprasLoteUseCase {
  constructor(private readonly repository: IReportsRepository) { }

  async getReportOrdemComprasLote(
    centroCusto: number,
    fornecedores: number[] | undefined,
    status: number,
    competencia: Date,
  ): Promise<void> {
    let normalizedStatus = 0;

    switch (status) {
      case 2:
        normalizedStatus = 1;
        break;

      case 3:
        normalizedStatus = 2;
        break;

      case 4:
        normalizedStatus = 3;
        break;
    }

    const response = await this.repository.getReportOrdemComprasLote(
      centroCusto,
      fornecedores !== undefined && fornecedores.length > 0 ? fornecedores : null,
      normalizedStatus,
      dayjs(competencia).startOf('month').toDate(),
    );

    const arquivoNome = `ordem_compras_lote_${dayjs(new Date()).format('DD_MM_YYYY_HH_mm_ss')}.${response.filenameExtension}`;
    const arquivo = response.bytes;

    await downloadBase64File(arquivoNome, arquivo);
  }
}
